<template>
  <div class="section-wrapper">
    <div class="sec3-trigger"></div>
    <!-- <div class="temporary-bg"></div> -->
    <div class="left-side sec-3-left-side">
      <div class="left-side-inner">
        <h3>
          Znamy się od kuchni... czyli poddajemy sprzęt Amica domowym testom!
        </h3>
        <video-carousel></video-carousel>
      </div>
    </div>
    <div class="right-side sec-3-right-side">
      <div class="right-side-inner">
        <h2>Ponownie gościmy w&nbsp;Waszych domach</h2>
        <p>
          Zakończyliśmy właśnie nabór do <strong>II etapu badań etnograficznych</strong>. To nasz autorski cykl pogłębionych badań, w ramach których użytkownicy <strong>oceniają poszczególne funkcjonalności naszego sprzętu, testując go w swoich domach</strong>. Wnioski z tych badań są nieocenione i służą nam do dalszego rozwoju produktów w kierunku jeszcze większej użyteczności i intuicyjności obsługi
        </p>
        <p>
          To właśnie w odpowiedzi na potrzeby naszych użytkowników powstały takie innowacje, jak <strong>OpenUp!</strong> – automatycznie otwierane drzwi piekarnika czy <strong>Touchless</strong> – okap sterowany gestem.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import videoCarousel from './video_carousel';

export default {
  mounted () {
    if (window.innerWidth > 1024) {
      const scene1 = this.$scrollmagic.scene({
        triggerElement: '.sec3-trigger',
        triggerHook: .1,
        duration: '100%',
      }).setPin('.sec-3-left-side')

      this.$scrollmagic.addScene(
        scene1
          // .addIndicators()
      )

      const scene2 = this.$scrollmagic.scene({
        triggerElement: '.sec3-trigger',
        triggerHook: .1,
        duration: '100%',
      }).setPin('.sec-3-right-side')

      this.$scrollmagic.addScene(
        scene2
          // .addIndicators()
      )
      
      // color overlay anim
      const scene3 = this.$scrollmagic.scene({
        triggerElement: '.sec2-trigger',
        triggerHook: .3,
        duration: '700%',
        // offset: '-250'
      })

      let Timeline = new TimelineMax();

      let bgColorOverlayRotateTween = TweenMax.to('.animation-color-overlay', 1, {
        rotation: -90
      }, 1)

      let bgColorOverlayMoveTween = TweenMax.to('.animation-color-overlay', 1, {
        xPercent: -100,
      }, 1)

      Timeline
        .add(bgColorOverlayRotateTween)
        .add(bgColorOverlayMoveTween)

      this.$scrollmagic.addScene(
        scene3
          .setTween(Timeline)
          // .addIndicators()
      )
    }

  },
  components: {
    videoCarousel
  }
}
</script>

<style lang="scss" scoped>
  .section-wrapper {
    width: 100%;
    min-height: calc(100vh - 70px);
    height: auto;
    padding: 15vw 0;
    position: relative;
    display: none;

    @media only screen and (max-width : 1024px) {
      min-height: auto;
      height: auto;
      padding: 4rem 0;
    }

    @media only screen and (max-width : 768px) {
      flex-direction: column;
      padding: 2rem 0;
    }

    .temporary-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px; 
      background: #faf5f2 url('../../../assets/images/zpl/bg-sec-3.jpg');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: 50% 100%;
      z-index: 0;
      pointer-events: none;
      display: none;

      @media only screen and (max-width : 1024px) {
        opacity: .08;
        display: block;
      }

      @media only screen and (max-width : 768px) {
        display: none;
      }
    }

    .left-side {
      // height: 100%;
      width: 50%;
      position: relative;

      @media only screen and (max-width : 1024px) {
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      @media only screen and (max-width : 768px) {
        width: 100%;
      }

      .left-side-inner {
        padding-left: 8.3333vw;
        height: 100%;
        width: 22.525vw;
        box-sizing: content-box;
        display: flex;
        flex-direction: column;
        justify-content: center;

        @media only screen and (max-width : 1024px) {
          padding-left: 16.66%;
          width: 75.01%;
        }

        @media only screen and (max-width : 768px) {
          padding-left: 8.33%;
          padding-right: 8.33%;
          width: calc(100% - 8.33% - 8.33%);
        }

        h3 {
          color: #e41429;
          font-size: 1.5rem;
          line-height: 1.9rem;
          margin-bottom: 2rem;
        }
      }
    }

    .right-side {
      // height: 100%;
      width: 50%;
      position: relative;

      @media only screen and (max-width : 768px) {
        width: 100%;
      }

      .right-side-inner {
        padding-left: 18.66vw;
        width: 22.525vw;
        height: 100%;
        box-sizing: content-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;

        @media only screen and (max-width : 1024px) {
          padding-left: 8.33%;
          width: 75.01%;
        }

        @media only screen and (max-width : 768px) {
          padding-left: 8.33%;
          padding-right: 8.33%;
          width: calc(100% - 8.33% - 8.33%);
        }

        h2 {
          color: #e41429;
          font-size: 3.2rem;
          margin-bottom: 4rem;
          font-weight: 600;
          margin-top: auto;
          width: 100%;

          @media only screen and (max-width : 1024px) {
            font-size: 2.2rem;
          }

          @media only screen and (max-width : 768px) {
            margin-top: 2rem;
            margin-bottom: 2rem;
          }
        }

        p {
          font-size: 1rem;
          line-height: 1.7rem;
          width: 100%;

          &:last-child {
            margin-top: 2rem;
            margin-bottom: auto;
          }
        }
      }
    }

  }
</style>